export class Bubble {

    private _state: boolean = false;
    private Bubbles: NodeListOf<HTMLElement> | null;
    private Anchor: HTMLElement | null;

    constructor() {
        this.Bubbles = document.querySelectorAll('.bubble');
        this.Anchor = document.querySelector('.bubble-anchor');
        console.log('bubbles working!');
        console.log(this.Bubbles[0], this.Bubbles[1], this.Bubbles[2], this.Bubbles[3])

        window.addEventListener('scroll', () => {
            const isElementInViewport = (el: HTMLElement): boolean => {
                const pos = el.getBoundingClientRect();
                return (
                    pos.top >= 0 &&
                    pos.left >= 0 &&
                    pos.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    pos.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            };

            const anchorReached: boolean = isElementInViewport(this.Anchor);

            if (anchorReached && !this.state) {
                this.state = true;
            } else if (!anchorReached && this.state) {
                this.state = false;
            }
        });
    }

    public set state(value: boolean) {
        this._state = value;

        if(this.state) {

            this.Bubbles[0].style.setProperty('left', '-40%');
            this.Bubbles[0].style.setProperty('height', '25%');
            this.Bubbles[0].style.setProperty('width', '40%');
            this.Bubbles[0].style.setProperty('top', '25%');

            this.Bubbles[1].style.setProperty('left', '0%');
            this.Bubbles[1].style.setProperty('width', '40%');
            this.Bubbles[1].style.setProperty('height', '80%');
            this.Bubbles[1].style.setProperty('top', '15%');

            this.Bubbles[2].style.setProperty('left', '40%');
            this.Bubbles[2].style.setProperty('width', '35%');
            this.Bubbles[2].style.setProperty('height', '40%');
            this.Bubbles[2].style.setProperty('top', '35%');

            this.Bubbles[3].style.setProperty('left', '75%');
            this.Bubbles[3].style.setProperty('width', '40%');
            this.Bubbles[3].style.setProperty('height', '25%');
            this.Bubbles[3].style.setProperty('top', '40%');

        } else {

            this.Bubbles.forEach(bubble => {
                bubble.style.removeProperty('width');
                bubble.style.removeProperty('height');
                bubble.style.removeProperty('left');
                bubble.style.removeProperty('top');
            });

        }
    }

    public get state(): boolean {
        return this._state;
    }
}
